import { HttpClient } from '@opallabs/api'

const buildReactionPayload = ({ activityId, emojiId }) => ({
  data: {
    type: 'reaction',
    attributes: {},
    relationships: {
      activity: {
        data: {
          id: activityId.toString(),
          type: 'activity',
        },
      },
      reaction_type: {
        data: {
          id: emojiId.toString(),
          type: 'reaction_type',
        },
      },
    },
  },
})

const postReaction = ({ reaction, onPostSuccess = (response) => response }) => {
  const url = '/reactions/v2'
  const payload = buildReactionPayload(reaction)

  return HttpClient()
    .post(url, payload)
    .then((reactionResponse) => onPostSuccess(reactionResponse.data))
}

export default postReaction
